import React from 'react';
import {
  ButtonWithIcon, Icon, Collapse
} from '@massds/mayflower-react';
import PropTypes from 'prop-types';
import DangerousWrapper from '../DangerousWrapper';
import './index.scss';

/**
 * An intro section for a page that cuts off text based on passed character limit,
 * adds an ellipsis, and a link to the intro/preamble page.
*/

// eslint-disable-next-line react/prefer-stateless-function
class ExpandableTextSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showButton: true
    };
  }

  handleClick = () => {
    const { open } = this.state;
    this.setState({
      open: !open
    });
  };

  onMountCallback = (element) => {
    const { minHeight } = this.props;
    if (minHeight > element.clientHeight) {
      this.setState({
        showButton: false
      });
    }
  }

  render() {
    const {
      text, lessLabel, moreLabel, htmlTag, minHeight, vetoLegend
    } = this.props;
    const { open, showButton } = this.state;
    return(
      <div className="ma__expandable-text-section">
        {text && text.length > 0 && (
          <Collapse in={open} dimension="height" minDimension={minHeight} minDimensionOnMount appear>
            <DangerousWrapper className="ma__expandable-text-section__text" htmlTag={htmlTag || 'span'} rawHtml={text} onMountCallback={this.onMountCallback} vetoLegend={vetoLegend} />
          </Collapse>
        )}
        {text && text.length > 0 && showButton && (
          <React.Fragment>
            <Collapse in={open} dimension="height" minDimensionOnMount={false}>
              <div className="ma__expandable-text-section__fade-overlay" />
            </Collapse>
            <span className="ma__expandable-text-section__expand-button">
              <ButtonWithIcon
                text={open ? (lessLabel || 'Read Less') : (moreLabel || 'Read More')}
                theme="c-primary"
                usage="quaternary-simple"
                type="button"
                icon={<Icon name="chevron" svgHeight={20} svgWidth={20} />}
                onClick={(e) => this.handleClick(e)}
                expanded={open}
                capitalized
              />
            </span>
          </React.Fragment>
        )}
      </div>
    );
  }
}

ExpandableTextSection.propTypes = {
  /** rawHtml to be clipped and rendered in the component * */
  text: PropTypes.string,
  /** The label on the button that collapses the text when it is expanded * */
  lessLabel: PropTypes.string,
  /** The label on the button that expands the text when it is collapsed * */
  moreLabel: PropTypes.string,
  /** The minimum height of the collapse section in pixels * */
  minHeight: PropTypes.number,
  /** The html tag you want the component to be. By default, this is a `div`. * */
  htmlTag: PropTypes.string,
  /** The veto legend object for adding footnote links, optional and used in the summary budget */
  vetoLegend: PropTypes.shape({
    legend: PropTypes.arrayOf(PropTypes.shape({
      index: PropTypes.string,
      innerWrapper: PropTypes.oneOf(['ma__gov-veto-inner__strike', 'ma__gov-veto-inner__add', 'ma__gov-veto-inner__strike--overridden', 'ma__gov-veto-inner__add--overridden']),
      outerWrapper: PropTypes.oneOf(['ma__gov-veto-outer__strike', 'ma__gov-veto-outer__add', 'ma__gov-veto-outer__strike--overridden', 'ma__gov-veto-outer__add--overridden'])
    }))
  })
};

ExpandableTextSection.defaultProps = {
  minHeight: 200
};

export default ExpandableTextSection;
